<button
	#usersBoxBtn
	class="btn btn-sm cv-btn-light btn-circular d-inline-flex border multiples-users-btn"
	(click)="toggleUsersBox()"
>
	<i class="fas fa-users position-relative">
		<span class="badge rounded-pill bg-warning text-dark">
			{{ orderUsers.length }}
		</span>
	</i>
</button>
<div #usersBox class="menu-context-box">
	<div class="box-content pb-2">
		<ul class="list-unstyled mb-0 p-1">
			<li class="d-flex align-items-center mb-1" *ngFor="let user of orderUsers">
				<div class="btn-circular cv-users-box-initials me-2">
					<span class="text-white">{{ user.initials }}</span>
				</div>
				<div class="text-nowrap">{{ user.fullName }}</div>
			</li>
		</ul>
	</div>
</div>
